import { makeStyles, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) =>
  createStyles({
    timesField: {
      flexBasis: '24%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      maxWidth: '24%',
      marginRight: theme.spacing(1),
    },

    label: {
      marginBottom: theme.spacing(1),
    },
  }),
);
